import React, { useState } from 'react';
import { Button, Dropdown, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useLanguage, SUPPORTED_LANGUAGES } from '../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const [open, setOpen] = useState(false);

  const handleMenuClick = ({ key }) => {
    changeLanguage(key);
    setOpen(false);
  };

  const items = Object.entries(SUPPORTED_LANGUAGES).map(([code, lang]) => ({
    key: code,
    label: (
      <Space>
        <span style={{ fontSize: '16px' }}>{lang.flag}</span>
        <span>{lang.name}</span>
        {currentLanguage === code && (
          <span style={{ color: '#1890ff', fontWeight: 'bold' }}>✓</span>
        )}
      </Space>
    ),
  }));

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleMenuClick,
        selectedKeys: [currentLanguage],
      }}
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
      trigger={['click']}
    >
      <Button
        type="text"
        icon={<GlobalOutlined />}
        style={{
          color: 'white',
          border: 'none',
          background: 'transparent',
          fontSize: '16px',
          padding: '4px 8px',
          borderRadius: '6px',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'transparent';
        }}
      >
        <Space>
          <span style={{ fontSize: '14px' }}>
            {SUPPORTED_LANGUAGES[currentLanguage].flag}
          </span>
          <span style={{ fontSize: '12px' }}>
            {SUPPORTED_LANGUAGES[currentLanguage].name}
          </span>
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher; 